import { TFunction } from 'i18next';
import { z } from 'zod';

import i18n from '@/core/i18n';
import { duplicateNameRefinement } from '@/modules/onboarding/common/utils/duplicate-name-refinement';

export const getMembersSchema = function (t: TFunction) {
  return z.object({
    entities: z
      .array(
        z.object({
          fullName: z
            .string()
            .min(2, i18n.t('authenticated.onboarding.team:validation.name.required')),
          email: z
            .string()
            .optional()
            .refine(val => !val || z.string().email().safeParse(val).success, {
              message: i18n.t('authenticated.onboarding.team:validation.email.invalid'),
            }),
        })
      )
      .min(1)
      .superRefine(
        duplicateNameRefinement(
          e => e.fullName,
          'fullName',
          i18n.t('authenticated.onboarding.team:validation.name.duplicate')
        )
      ),
  });
};

export type MembersFormData = z.infer<ReturnType<typeof getMembersSchema>>;
